var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeployCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.25 1.25)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#292D3B",
    strokeWidth: 2.327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 43.792,
    cy: 43.75,
    rx: 43.634,
    ry: 43.75
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#292D3B",
    strokeWidth: 2.327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 43.792,
    cy: 43.75,
    rx: 26.413,
    ry: 26.483
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6BC6C4",
    fillRule: "nonzero",
    opacity: 0.47,
    cx: 46.119,
    cy: 46.083,
    rx: 11.519,
    ry: 11.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "#292D3B",
    strokeWidth: 2.327,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 43.792,
    cy: 43.75,
    rx: 11.519,
    ry: 11.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.678 45.066c-.643-2.203-2.272-4.594-5.143-4.727-2.872-.133-4.562 2.1-5.26 4.244",
    stroke: "#292D3B",
    strokeWidth: 1.813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#292D3B",
    strokeWidth: 2.148,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M59.486 45.106l2.097.667.023-2.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.499 45.066c-.642-2.203-2.271-4.594-5.143-4.727s-4.561 2.1-5.26 4.244",
    stroke: "#292D3B",
    strokeWidth: 1.813,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#292D3B",
    strokeWidth: 2.148,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M74.305 45.106l2.1.667.023-2.84"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgDeployCircles as ReactComponent };